module.exports = __webpack_public_path__ + "media/images/ui-icons_309bbf_256x240-8fc2448cbbf3754c1e4209f4da463139.png";